var AdjustCard = function() {
    this.$pickup = $('.pickup').find('.card-image');
    this.timer = false;
};

AdjustCard.prototype = {
    init: function() {
        var _this = this;
        _this.reziseCard();

        $window.on('resize', _this.reziseCard);
    },
    reziseCard: function() {
        var _this = this;
        _this.$pickup = $('.pickup').find('.card-image');
        //console.log();
        if (_this.timer !== false) {
            clearTimeout(_this.timer);
        }

        _this.$pickup.css({
            height: 'auto'
        });
        _this.timer = setTimeout(function(){
            var cardImageHeight = _this.$pickup.eq(0).height();
            _this.$pickup.css({
                height: cardImageHeight
            });
        }, 200);
    }
};

module.exports = AdjustCard;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/adjustCard.js
 **/